import { render, staticRenderFns } from "./ReadIndicatorBadge.vue?vue&type=template&id=5c810984&scoped=true&"
import script from "./ReadIndicatorBadge.vue?vue&type=script&lang=js&"
export * from "./ReadIndicatorBadge.vue?vue&type=script&lang=js&"
import style0 from "./ReadIndicatorBadge.vue?vue&type=style&index=0&id=5c810984&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c810984",
  null
  
)

export default component.exports